module.exports = __webpack_public_path__ + "img/CAAC80_FAEBD5_F2DEBF_EAD1AF-256px.543a0e6a.png";